import styled from "styled-components";

export const WrapperToolbarButton = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
`;

export const ToolbarButton = styled.div`
  display: inline-flex;
  align-items: center;

  span {
    font-family: "AllianceNo2-SemiBold" !important;
    font-weight: 100 !important;
    font-size: 12px !important;
    color: var(--Text-Primary) !important;
  }

  .material-icons {
    font-size: 18px !important;
    line-height: 1.2em;
    padding: 0 2px;
    color: var(--Text-Primary) !important;
  }
  cursor: pointer;
`;

export const SearchWrapper = styled.div`
  input[type="search"] {
    border-radius: 0;
    box-shadow: none;
    font-size: 12px;
    border: 1px solid #aaa;
    border-radius: 3px;
    padding: 5px;
    color: var(--Text-Primary);
  }
  label {
    font-family: "AllianceNo2-SemiBold" !important;
    font-weight: 100;
    color: var(--Text-Primary);
    margin-right: 5px;
  }
`;
